<template>
  <v-container>

    <v-col cols="12" class="mb-1">
      <h3>Abertura De Chamado Versão Atualizada</h3>
    </v-col>


    <!-- Dialog para confirmação de abertura de chamado -->
    <v-dialog v-model="dialogConfirmarChamado" persistent max-width="500px">
      <v-card>
        <!-- Título do diálogo -->
        <v-card-title class="text-h6 font-weight-bold bg-primary white--text">
          Atenção! Abrir Chamado
        </v-card-title>

        <!-- Divisor -->
        <v-divider></v-divider>

        <!-- Conteúdo do diálogo -->
        <v-card-text class="py-4">
          <p class="mb-2 text-body-1 font-weight-regular">
            Deseja abrir o chamado com os dados preenchidos?
          </p>
        </v-card-text>

        <!-- Divisor -->
        <v-divider></v-divider>

        <!-- Botões de ação -->
        <v-card-actions class="justify-end">
          <v-btn text @click="closeDialogChamado" color="secondary">Cancelar</v-btn>
          <v-btn @click="abrirChamado" color="primary" :loading="loadingDialog" class="ml-2" elevation="1">
            Confirmar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <!-- Diálogo de confirmação de cancelamento -->
    <v-dialog v-model="cancelarDialog" max-width="500">
      <v-card>
        <v-card-title class="text-danger"> Confirmar Cancelamento</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          Tem certeza de que deseja cancelar? Todas as mudanças serão perdidas.
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="cancelarDialog = false">Não</v-btn>
          <v-btn color="red darken-1" text @click="voltarMenu">Sim, Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Diálogo de Carregamento -->
    <v-dialog v-model="loadingDialog" persistent max-width="300">
      <v-card>
        <v-card-text class="text-center">
          <v-progress-circular indeterminate color="green"></v-progress-circular>
          <p>{{ mensagemDialog }}</p>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Diálogo de Detalhes da Máquina -->
    <div>
      <!-- #chefe -->
      <v-row dense v-if="!chefeSelecionado">
        <v-col cols="9">
          <v-text-field label="ID Chefe" v-model="id_chefe" @keyup.enter="buscarChefe" :disabled="loading"
            variant="outlined"></v-text-field>
        </v-col>
        <v-col :cols="isMobile() ? 12 : 'auto'" class="text-right">
          <v-btn color="primary" @click="buscarChefe">
            <v-icon left>mdi-magnify</v-icon>
            Pesquisar
          </v-btn>
        </v-col>
      </v-row>


      <div v-if="chefeSelecionado">

        <!-- Informações do Chefe -->
        <v-card class="mb-4 chefe-card">
          <v-row align="center" justify="space-between">

            <v-col cols="auto">
              <span><strong>Chefe:</strong> {{ chefeSelecionado.id }} - {{ chefeSelecionado.nome }}</span>
            </v-col>
            <v-col cols="auto">
              <v-btn color="primary" @click="chefeSelecionado = null">
                <v-icon left>mdi-magnify</v-icon>
                Pesquisar
              </v-btn>
            </v-col>

          </v-row>
        </v-card>


        <!-- Seleção de Máquina -->
        <v-row v-if="!maquinaSelecionada">
          <v-col cols="9">
            <v-text-field label="ID Máquina" v-model="id_maquina" @keyup.enter="buscarMaquina"
              variant="outlined"></v-text-field>
          </v-col>

          <v-col :cols="isMobile() ? 12 : 'auto'" class="text-right">
            <v-btn color="primary" @click="buscarMaquina">
              <v-icon left>mdi-magnify</v-icon>
              Pesquisar
            </v-btn>
          </v-col>
        </v-row>

        <!-- Caso Máquina esteja selecionada -->
        <v-card v-else class="mb-4 chefe-card">

          <v-row align="center" justify="space-between">
            <v-col cols="auto">
              <span><strong>
                  Máquina {{ formatId(maquinaSelecionada.id) }} - {{ maquinaSelecionada.descricao_maquina }}
                </strong></span>
            </v-col>
            <v-col cols="auto">
              <span><strong>
                  Setor {{ maquinaSelecionada.setor.descricao_setor }}
                </strong></span>
            </v-col>

            <v-col cols="auto">
              <span><strong>
                  Fila {{ maquinaSelecionada.fila }} - Posição {{ maquinaSelecionada.posicao }}
                </strong></span>
            </v-col>



            <v-col cols="auto">
              <span><strong>
                  Fila {{ maquinaSelecionada.fila }} - Posição {{ maquinaSelecionada.posicao }}
                </strong></span>
            </v-col>

            <v-col cols="auto">
              <v-btn color="primary" @click="modalVisibleInformacoes = true">
                <v-icon left>mdi-magnify</v-icon>
                Informações
              </v-btn>
            </v-col>

            <v-col cols="auto">
              <v-btn color="primary" @click="maquinaSelecionada = null">
                <v-icon left>mdi-magnify</v-icon>
                Pesquisar
              </v-btn>
            </v-col>
          </v-row>

          <ComponenteMaquinaDialog :idMaquina="id_maquina ? Number(id_maquina) : null" :ativa="modalVisibleInformacoes"
            :habilitarSelecao="false" @update:ativa="modalVisibleInformacoes = $event" @close="closeModal"
            @maquina-selecionada="handleMaquinaSelecionada" />

        </v-card>


        <!-- Tipo De Manutenção Show Da Tela -->
        <v-col cols="12">
          <v-card class="mb-4 chefe-card">
            <v-row :align="isMobile() ? 'start' : 'center'" :justify="isMobile() ? 'start' : 'space-between'" dense>

              <!-- Tipo de Manutenção -->
              <v-col :cols="isMobile() ? 12 : 'auto'" class="mb-2">
                <span v-if="tipoManutencaoSelecionado">
                  <strong>Tipo De Manutenção:</strong> {{ tipoManutencaoSelecionado.tipo_manutencao }}
                </span>
                <span v-else>
                  SELECIONE O TIPO DE MANUTENÇÃO
                </span>
              </v-col>

              <!-- Prioridade -->
              <template v-if="tipoManutencaoSelecionado">
                <v-col :cols="isMobile() ? 12 : 'auto'" class="ml-3 mb-2">
                  <span><strong>Prioridade:</strong> {{ tipoManutencaoSelecionado.prioridade.prioridade }}</span>
                </v-col>

                <!-- Tempo Máximo -->
                <v-col :cols="isMobile() ? 12 : 'auto'" class="ml-3 mb-2">
                  <span><strong>Tempo Máximo:</strong> {{ tipoManutencaoSelecionado.tempo_maximo }}</span>
                </v-col>
              </template>

              <!-- Botão de Pesquisa -->
              <v-col :cols="isMobile() ? 12 : 'auto'" class="ml-3 text-right">
                <v-btn color="primary" @click="abrirSheetTipoManutencao">
                  <v-icon left>mdi-magnify</v-icon>
                  Pesquisar
                </v-btn>
              </v-col>

            </v-row>
          </v-card>
        </v-col>

        <!-- Bottom Sheet para seleção de Tipo de Manutenção -->
        <v-bottom-sheet v-model="sheetTipoManutencao" :fullscreen="isMobile()" max-width="600px">
          <v-sheet class="pa-4">
            <v-card>
              <!-- Lista com scroll -->
              <div style="max-height: 600px; overflow-y: auto;">
                <v-list>
                  <v-list-subheader>Selecione o Tipo de Manutenção</v-list-subheader>
                  <v-list-item v-for="tipo in getTiposManutencaoFiltrados()" :key="tipo.id"
                    @click="selectTipoManutencao(tipo)">
                    <v-list-item-title>
                      {{ tipo.tipo_manutencao }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </div>
              <v-divider></v-divider>
              <!-- Campo de pesquisa no final -->
              <v-text-field v-model="searchTipoManutencao" label="Pesquisar Tipo de Manutenção" clearable
                class="mt-2 mr-2 ml-2" variant="underlined" prepend-icon="mdi-magnify"
                style="background-color: white;"></v-text-field>
            </v-card>
          </v-sheet>
        </v-bottom-sheet>



        <!-- Mecânico Show da Tela -->
        <v-col cols="12">
          <v-card class="mb-4 chefe-card">
            <v-row :align="isMobile() ? 'start' : 'center'" :justify="isMobile() ? 'start' : 'space-between'" dense>
              <v-col :cols="isMobile() ? 12 : 'auto'" class="mb-2">
                <span v-if="mecanicoSelecionado">
                  <strong>Mecânico:</strong> {{ mecanicoSelecionado.id }} - {{ mecanicoSelecionado.nome_mecanico }}
                </span>
                <span v-else>
                  SELECIONE O MECÂNICO
                </span>
              </v-col>
              <v-col :cols="isMobile() ? 12 : 'auto'" class="text-right">
                <v-btn color="primary" @click="abrirSheetMecanico">
                  <v-icon left>mdi-magnify</v-icon>
                  Pesquisar
                </v-btn>
              </v-col>
            </v-row>
          </v-card>
        </v-col>

        <!-- Bottom Sheet para seleção de Mecânico -->
        <v-bottom-sheet v-model="sheetMecanico" :fullscreen="isMobile()" max-width="600px">
          <v-sheet class="pa-4">
            <v-card>
              <!-- Lista de mecânicos com rolagem -->
              <div style="max-height: 400px; overflow-y: auto;">
                <v-list>
                  <v-list-subheader>Selecione o Mecânico</v-list-subheader>

                  <!-- Opção para não selecionar nenhum mecânico -->
                  <v-list-item @click="selectMecanico(null)">
                    <v-list-item-title>
                      Não selecionar mecânico agora
                    </v-list-item-title>
                  </v-list-item>

                  <!-- Lista de mecânicos -->
                  <v-list-item v-for="mecanico in getMecanicosFiltrados()" :key="mecanico.id"
                    @click="selectMecanico(mecanico)">
                    <v-list-item-title>
                      {{ mecanico.nome_mecanico }}
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      Contato: {{ mecanico.fone }}
                    </v-list-item-subtitle>
                  </v-list-item>
                </v-list>
              </div>




              <v-divider></v-divider>
              <!-- Campo de pesquisa no final -->
              <v-text-field v-model="searchMecanico" variant="underlined" label="Pesquisar Mecânico" clearable
                class="mt-2 mr-2 ml-2" prepend-icon="mdi-magnify" style="background-color: white;"></v-text-field>
            </v-card>
          </v-sheet>
        </v-bottom-sheet>






        <!-- Observação de Abertura -->
        <v-col cols="12">
          <v-textarea label="Observação de Abertura" v-model="observacaoAbertura" outlined
            :rules="[rules.validaObservacao]"></v-textarea>
        </v-col>




      </div>


    </div>



    <!-- Modal de Sucesso -->



    <!-- Chamado Salvo Com Sucesso ! -->
    <v-dialog v-model="modalSucesso" persistent max-width="400">
      <v-card>
        <v-card-title class="headline">
          <v-icon large color="green">mdi-check-circle</v-icon>
          <span class="ml-3">Chamado Aberto com Sucesso</span>
        </v-card-title> <v-divider></v-divider>
        <v-card-text class="text-center">
          <div class="my-5 d-flex flex-column align-center justify-center">
            <span class="headline">Número do Chamado:</span>
            <div :style="{ fontSize: '48px', fontWeight: 'bold' }">{{ chamadoId }}</div>
          </div>
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="voltarConsultaChamados">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>






    <!-- Área dos Botões -->
    <div class="buttons-container">
      <v-row justify="center">
        <!-- Botões de Ação -->
        <!-- <v-btn color="green" @click="confirmFinalizar">
          Finalizar
        </v-btn> -->
        <v-btn color="secondary" class="mx-2" @click="opcaoconfirmCancelar">
          <v-icon left>mdi-arrow-left</v-icon>
          Voltar
        </v-btn>

        <v-btn :disabled="!isBotaoHabilitado" color="green" @click="perguntarSeVaiAbrir">
          Abrir Chamado
        </v-btn>

        <!-- quero criar um checkbox se vai enviar mensage         m -->
        <v-checkbox v-model="enviarMensagem" label="Enviar Mensagem"></v-checkbox>

      </v-row>
    </div>




  </v-container>
</template>

<script>
import { chamadosService } from "@/services/chamadosService";
import { funcionarioService } from "@/services/funcionarioService";
import { useUserStore } from "@/store/userStore";
import ComponenteMaquinaDialog from "@/components/ComponenteMaquinaDialog.vue";

import { useToast } from "vue-toastification";

const toast = useToast();

export default {
  components: {
    ComponenteMaquinaDialog,
  },
  data() {
    return {
      cancelarDialog: false, // Controla a visibilidade do diálogo de cancelamento
      chamadoId: null, // ID do chamado aberto
      modalSucesso: false, // Controle do modal

      mensagemWhatzap: "",
      pessoasReceberMensagens: [], // Adicionando a inicialização do array
      dialogConfirmarChamado: false, // Controla a visibilidade do diálogo de confirmação


      modalVisibleInformacoes: false, // visualizar os detalhes da máquina

      enviarMensagem: true,
      mensagemDialog: "Carregando...",
      loadingDialog: true,
      loading: false,
      id_chefe: "",
      chefeSelecionado: null,
      tiposManutencao: [],
      tipoManutencaoSelecionado: null,
      sheetTipoManutencao: false, // Controla a visibilidade do Bottom Sheet
      searchTipoManutencao: "", // Armazena o texto da pesquisa
      tiposManutencao: [], // Lista dos tipos de manutenção
      tipoManutencaoSelecionado: null, // Tipo de manutenção selecionado
      setorSelecionado: null, 

      id_maquina: null,
      maquinaSelecionada: null,
      observacaoAbertura: "",
      // Regras de validação
      rules: {
        validaObservacao: (value) =>
          value && value.trim().length > 0 || "Observação de abertura é obrigatória.",
        validaTipoManutencao: (value) =>
          value || "Tipo de manutenção é obrigatório.",
        validaIdChefe: (value) =>
          value && value > 0 || "Chefe é obrigatório.",
        validaMaquina: (value) =>
          value || "Máquina é obrigatória.",
      },



      sheetMecanico: false, // Controla a visibilidade do Bottom Sheet
      searchMecanico: "", // Texto de pesquisa
      mecanicos: [], // Lista de mecânicos
      mecanicoSelecionado: null, // Mecânico selecionado

    };

  },

  created() {
    this.id_chefe = String(this.ObjUsuario.id_funcionario).trim();
  },

  computed: {
    // Adicionando userStore como propriedade computada
    userStore() {
      return useUserStore();
    },
    
    isBotaoHabilitado() {
      return this.verificarFormularioBotao();
    },

    nomeUsuario() {
      return this.userStore.objetoUsuario?.name || "Sem Usuário";
    },
    ObjUsuario() {
      return this.userStore.objetoUsuario || "Sem Usuário";
    },
  },
  methods: {


    perguntarSeVaiAbrir() {
      this.dialogConfirmarChamado = true;
    },
    closeDialogChamado() {
      this.dialogConfirmarChamado = false; // Fecha o diálogo
    },


    // Método para confirmar o cancelamento
    confirmCancelar() {
      this.cancelarDialog = true;
    },

    // Ação de cancelamento
    cancelarAcao() {
      this.cancelarDialog = false;
      this.$router.push({ name: "MenuDefault" }).catch(() => { });
    },

    opcaoconfirmCancelar() {
      // Abre o diálogo de confirmação
      // this.$router.push({ name: 'MenuDefault' }).catch(() => { });
      this.cancelarDialog = true;
    },
    voltarMenu() {
      this.$router.push({ name: "MenuDefault" }).catch(() => { });
    },

    voltarConsultaChamados() {
      // queria voltar pra ultima rota 
      this.modalSucesso = false;
      this.closeDialogChamado();
        this.$router.go(-1);
    },
    verificarFormulario() {
      // Verificar Observação
      if (!this.observacaoAbertura || this.observacaoAbertura.trim() === "") {

        toast.error("Observerção é obrigatoria !")
        return false;
      }

      // Verificar Tipo de Manutenção
      if (!this.tipoManutencaoSelecionado) {
        toast.error("Tipo de manutenção é obrigatório.");
        return false;
      }

      // Verificar ID do Chefe
      if (!this.id_chefe || this.id_chefe.trim() === "") {
        toast.error("Chefe é obrigatório.");
        return false;
      }

      // Verificar Máquina Selecionada
      if (!this.maquinaSelecionada) {
        toast.error("Máquina é obrigatória.");
        return false;
      }

      return true; // Tudo está válido
    },


    verificarFormularioBotao() {
      // VERIFICAR SE O MECANICO ESTA SELECIONADO 
      if (!this.mecanicoSelecionado) {
        return false;
      }
      // Verificar Observação
      if (!this.observacaoAbertura || this.observacaoAbertura.trim() === "") {

        return false;
      }

      // Verificar Tipo de Manutenção
      if (!this.tipoManutencaoSelecionado) {
        return false;
      }

      // Verificar ID do Chefe
      if (!this.id_chefe || this.id_chefe.trim() === "") {
        return false;
      }

      // Verificar Máquina Selecionada
      if (!this.maquinaSelecionada) {
        return false;
      }

      return true; // Tudo está válido
    },

    closeModal() {
      this.modalVisibleInformacoes = false;
    },

    // apenas pra fechar o modal das maquinas
    handleMaquinaSelecionada(maquina) {
      console.log("Máquina selecionada:", maquina);
      this.modalVisible = false;
    },
    formatId(id) {
      return String(id).padStart(4, "0");
    },
    abrirSheetTipoManutencao() {
      this.sheetTipoManutencao = true;
    },
    isMobile() {
      return window.innerWidth <= 600;
    },

    async buscarChefe() {
  try {
    if (this.loadingDialog) return; // Evita buscar enquanto carrega
    this.mensagemDialog = "Buscando chefe...";
    this.loadingDialog = true;

    const chefe = await funcionarioService.fetchFuncionarioPorId(this.id_chefe);
    if (chefe) {
      this.chefeSelecionado = chefe;
      // toast.success("Chefe encontrado!");
      this.carregarTiposManutencao(); // Carrega os tipos de manutenção relacionados
      this.sheetTipoManutencao = true;
    } else {
      throw new Error("Chefe não encontrado."); // Garante que a mensagem de erro seja capturada
    }
  } catch (error) {
    console.error(error);
    // REMOVIDO: A chamada do sendResponse não é necessária aqui, pois este método não é um listener de mensagens
    // sendResponse({ status: 'error', message: error.message });
    
    toast.error(error.message || "Erro ao buscar chefe."); // Exibe o erro ao usuário
    this.sheetTipoManutencao = false;
    this.sheetMecanico = false;
  } finally {
    this.loadingDialog = false; // Garante que o indicador de carregamento seja desligado
  }
},




async buscarMaquina() {
  // ADDED: Processa o id da máquina removendo os 3 primeiros caracteres se forem letras e tornando maiúsculas
  let idMaquina = this.id_maquina.trim().toUpperCase();
  if (/^[A-Z]{3}/.test(idMaquina)) {
    idMaquina = idMaquina.substring(3);
  }

  // Evita iniciar nova busca se já estiver carregando
  if (this.loadingDialog) return;

  this.mensagemDialog = "Buscando máquina...";
  this.loadingDialog = true;

  try {
    // ADDED: Realiza a consulta da máquina através do serviço
    const maquina = await chamadosService.consultaMaquina(idMaquina);
    if (maquina) {
      this.maquinaSelecionada = maquina;
      // toast.success("Máquina encontrada!");
    } else {
      toast.error("Máquina não encontrada.");
    }
  } catch (error) {
    console.error(error);
    toast.error("Erro ao buscar máquina.");
  } finally {
    // ADDED: Garante que o indicador de carregamento seja desativado, independentemente do resultado
    this.loadingDialog = false;
  }
},

    async carregarTiposManutencao() {
      try {
        // Simulação ou chamada à API para carregar os tipos de manutenção
        this.tiposManutencao = await chamadosService.consultaTipoManutencao();
      } catch (error) {
        console.error("Erro ao carregar tipos de manutenção:", error);
        toast.error("Erro ao carregar tipos de manutenção.");
      }
    },
    getTiposManutencaoFiltrados() {
      return this.tiposManutencao.filter((tipo) =>
        tipo.tipo_manutencao
          .toLowerCase()
          .includes(this.searchTipoManutencao.toLowerCase())
      );
    },
    selectTipoManutencao(tipo) {
      this.tipoManutencaoSelecionado = tipo; // Define o tipo de manutenção selecionado
      this.sheetTipoManutencao = false; // Fecha o Bottom Sheet
      this.sheetMecanico = true;

      // toast.success(`Tipo de manutenção selecionado: ${tipo.tipo_manutencao}`);
    },



    abrirSheetMecanico() {
      this.sheetMecanico = true;
    },

    async carregarMecanicos() {
      try {
        // Simulação ou chamada à API para obter a lista de mecânicos
        this.mecanicos = await chamadosService.consultaMecanicos();
        this.loadingDialog = false;

      } catch (error) {
        this.loadingDialog = false;

        console.error("Erro ao carregar mecânicos:", error);
        toast.error("Erro ao carregar mecânicos.");
      }
    },
    getMecanicosFiltrados() {
      // Filtra os mecânicos com base no texto de pesquisa
      return this.mecanicos.filter((mecanico) =>
        mecanico.nome_mecanico
          .toLowerCase()
          .includes(this.searchMecanico.toLowerCase())
      );
    },
    selectMecanico(mecanico) {
      // Define o mecânico selecionado
      this.mecanicoSelecionado = mecanico;
      this.sheetMecanico = false; // Fecha o Bottom Sheet
      //  toast.success(`Mecânico selecionado: ${mecanico.nome_mecanico}`);
    },


    async confirmarWhatzap() {
  this.mensagemDialog = "Verificando conexão do WhatsApp...";
  this.loadingDialog = true;

  try {
    // ✅ VERIFICAR STATUS DA INSTÂNCIA PRIMEIRO
    const statusCheck = await chamadosService.verificarStatusWhatsapp({
      empresa_id: 1
    });

    const statusInstancia = statusCheck?.data?.response?.instance?.state;
    const nomeInstancia = statusCheck?.data?.response?.instance?.instanceName;

    // ✅ SE NÃO ESTIVER CONECTADO, PARAR AQUI
    if (statusInstancia !== 'open') {
      this.loadingDialog = false;
      this.mostrarErroConexao(statusInstancia, nomeInstancia);
      return;
    }

    // ✅ SE CONECTADO, CONTINUAR COM ENVIO
    this.mensagemDialog = `WhatsApp conectado (${nomeInstancia})! Preparando envio...`;
    
    // Filtrar apenas as pessoas que possuem telefone válido
    const pessoasComTelefone = this.pessoasReceberMensagens.filter(
      (pessoa) => pessoa.celular && pessoa.celular.trim() !== ""
    );

    if (pessoasComTelefone.length === 0) {
      throw new Error("Nenhum telefone válido encontrado para envio.");
    }

    const resultadosEnvio = [];

    for (const pessoa of pessoasComTelefone) {
      this.mensagemDialog = `Enviando para: ${pessoa.nome} (${pessoa.celular})`;

      try {
        // Dados para envio ao backend
        const mensagemData = {
          telefone: pessoa.celular.trim(),
          texto: this.mensagemWhatzap.trim(),
          empresa_id: 1,
        };

        // Enviar mensagem via API
        const response = await chamadosService.enviarWhatsapp(mensagemData);

        if (response && response.data) {
          const { status, message, codigo_erro } = response.data;

          // ✅ TRATAR DIFERENTES TIPOS DE RESPOSTA
          if (status === "sucesso" || status === "Processando") {
            resultadosEnvio.push({
              pessoa: pessoa.nome,
              telefone: pessoa.celular,
              status: "✅ Enviado com sucesso",
              detalhes: message || "Mensagem processada"
            });
          } else if (codigo_erro === "INSTANCE_NOT_CONNECTED") {
            // ✅ SE DESCONECTOU DURANTE O ENVIO
            this.loadingDialog = false;
            this.mostrarErroConexao("close", nomeInstancia);
            return;
          } else {
            resultadosEnvio.push({
              pessoa: pessoa.nome,
              telefone: pessoa.celular,
              status: "❌ Erro no envio",
              detalhes: message || "Status inválido"
            });
          }
        } else {
          resultadosEnvio.push({
            pessoa: pessoa.nome,
            telefone: pessoa.celular,
            status: "❌ Erro no servidor",
            detalhes: "Resposta inválida do servidor"
          });
        }
      } catch (error) {
        console.error(`Erro ao enviar mensagem para ${pessoa.nome}:`, error);
        
        // ✅ TRATAR ERROS ESPECÍFICOS
        let statusErro = "❌ Erro desconhecido";
        let detalhes = error.message || "Erro ao enviar mensagem";
        
        if (error.response?.data?.codigo_erro === "INSTANCE_NOT_CONNECTED") {
          this.loadingDialog = false;
          this.mostrarErroConexao("close", nomeInstancia);
          return;
        } else if (error.response?.status === 408) {
          statusErro = "❌ Timeout";
          detalhes = "WhatsApp demorou para responder";
        } else if (error.response?.data?.message) {
          detalhes = error.response.data.message;
        }
        
        resultadosEnvio.push({
          pessoa: pessoa.nome,
          telefone: pessoa.celular,
          status: statusErro,
          detalhes: detalhes
        });
      }

      // ✅ AGUARDAR ENTRE ENVIOS (3 segundos)
      await new Promise((resolve) => setTimeout(resolve, 3000));
    }

    // ✅ MOSTRAR RESULTADO FINAL
    this.mensagemDialog = "Envio Concluído!";
    this.mostrarRelatorioEnvio(resultadosEnvio);
    
  } catch (error) {
    console.error("Erro geral ao enviar mensagens:", error);
    this.mostrarErroGeral(error);
  } finally {
    this.loadingDialog = false;
  }
},


// ✅ ADICIONAR ESTES MÉTODOS NO SEU SCRIPT

// Método para mostrar erro de conexão
mostrarErroConexao(status, instancia) {
  const mensagens = {
    'close': {
      titulo: '📱 WhatsApp Desconectado',
      texto: `A instância "${instancia}" está desconectada. É necessário reconectar antes de enviar mensagens.`,
      botao: 'Ir para Configurações'
    },
    'connecting': {
      titulo: '🔄 WhatsApp Conectando',
      texto: `A instância "${instancia}" está tentando conectar. Aguarde alguns momentos.`,
      botao: 'Tentar Novamente'
    },
    'qr': {
      titulo: '📷 QR Code Pendente',
      texto: `A instância "${instancia}" está aguardando leitura do QR Code.`,
      botao: 'Ver QR Code'
    }
  };

  const config = mensagens[status] || {
    titulo: '❓ Status Desconhecido',
    texto: `A instância "${instancia}" está em estado desconhecido: ${status}`,
    botao: 'Verificar Configurações'
  };

  // ✅ NOTIFICAÇÃO COM TOAST
  toast.error(config.texto);

  // ✅ OPÇÃO DE REDIRECIONAR PARA CONFIGURAÇÕES
  toast.info("Clique aqui para ir às configurações do WhatsApp", {
    onClick: () => {
      this.$router.push({ name: 'WhatsAppConfig' });
    },
    timeout: 5000
  });
},

// Método para mostrar relatório de envio
mostrarRelatorioEnvio(resultados) {
  const sucessos = resultados.filter(r => r.status.includes('✅')).length;
  const erros = resultados.filter(r => r.status.includes('❌')).length;
  
  console.table(resultados);
  
  // ✅ NOTIFICAÇÕES BASEADAS NO RESULTADO
  if (sucessos > 0 && erros === 0) {
    toast.success(`✅ Todas as ${sucessos} mensagens foram enviadas com sucesso!`);
  } else if (sucessos > 0 && erros > 0) {
    toast.warning(`⚠️ ${sucessos} enviadas, ${erros} com erro.`);
    
    // Mostrar detalhes dos erros
    const pessoasComErro = resultados
      .filter(r => r.status.includes('❌'))
      .map(r => r.pessoa)
      .join(', ');
    
    toast.error(`❌ Erros para: ${pessoasComErro}`);
  } else {
    toast.error(`❌ Todas as ${erros} mensagens falharam.`);
  }
},

// Método para mostrar erro geral
mostrarErroGeral(error) {
  const mensagemErro = error.message || 'Erro desconhecido ao enviar mensagens';
  toast.error(`❌ ${mensagemErro}`);
},

// ✅ ADICIONAR MÉTODO PARA VERIFICAR STATUS DO WHATSAPP
async verificarStatusWhatsapp(params) {
  try {
    // Assumindo que você tem um serviço para verificar status
    return await chamadosService.verificarStatusWhatsapp(params);
  } catch (error) {
    console.error("Erro ao verificar status:", error);
    throw error;
  }
},




    async abrirChamado() {
      if (!this.verificarFormulario()) return;

      if (this.mecanicoSelecionado?.id) {
        this.mensagemDialog = "mecanico solicitado...";
        console.log("mecanico solicitado...");
      }
      else { console.log("nao tem mecanico ..."); }


      this.loadingDialog = true; // Ativa o indicador de carregamento
      this.mensagemDialog = "Abrindo chamado...";
      // vamos prechencher a data data_solicitacao_mecanico com a data atual caso contrario vai ficar null
      let data_solicitacao_mecanico = this.mecanicoSelecionado
        ? new Date().toISOString().split("T")[0]
        : null;

      // 1 = aberto | 2 = mecanico solicitado
      let id_status = data_solicitacao_mecanico ? 2 : 1;



      // Tempo de chamado do mecânico
      let tempo_chamado_mecanico = data_solicitacao_mecanico ? 0 : null;



      try {
        const chamadoData = {
          data_cadastro: new Date().toISOString().replace('T', ' ').slice(0, 19), // Data e hora atual
          data_abertura: new Date().toISOString().replace('T', ' ').slice(0, 19), // Data e hora atual
          id_funcionario_abertura: this.chefeSelecionado.id, // ID do chefe selecionado
          id_maquina: this.maquinaSelecionada.id, // ID da máquina selecionada
          id_setor: this.maquinaSelecionada.setor?.id, // ID do setor da máquina
          id_subsetor: this.maquinaSelecionada.sub_setor?.id || null, // ID do subsetor da máquina (se existir)
          id_status_chamado: id_status, // Status inicial do chamado
          id_tipo_manutencao: this.tipoManutencaoSelecionado?.id || null, // ID do tipo de manutenção selecionado
          id_prioridade: this.tipoManutencaoSelecionado?.prioridade?.id || null, // ID da prioridade
          tempo_estimado_conserto: this.tipoManutencaoSelecionado?.tempo_maximo || null, // Tempo estimado para o conserto
          observacao_abertura: this.observacaoAbertura.trim(), // Observação do usuário
          id_mecanico: this.mecanicoSelecionado?.id || null, // ID do mecânico (se selecionado),
          data_solicitacao_mecanico: data_solicitacao_mecanico, // Data de solicitação do mecânico
          tempo_chamado_mecanico: tempo_chamado_mecanico, // Tempo de chamado do mecânico
          enviar_mensagem: this.enviarMensagem
        };

        const response = await chamadosService.abrirChamado(chamadoData);



        if (response.id) {
          this.chamadoId = response.id; // Armazena o ID do chamado

         
          if (this.enviarMensagem) {
            
          
         
          //  chamado aberto
           const chamado = await chamadosService.ConsultaPorIdChamado(this.chamadoId);
           
 
      // Limpa a lista de pessoas para receber mensagens
      this.pessoasReceberMensagens = [];

      // Se há mecânico selecionado, adiciona apenas ele
      if (this.mecanicoSelecionado && this.mecanicoSelecionado.fone) {
        this.pessoasReceberMensagens.push({
          id: this.mecanicoSelecionado.id,
          nome: this.mecanicoSelecionado.nome_mecanico,
          celular: this.mecanicoSelecionado.fone,
          selecionado: true
        });
      } else {
        // Se não há mecânico selecionado, usa os funcionários dos robôs
        chamado.tipo_manutencao.robos.forEach((robo) => {
          if (
            robo.funcionarios_whatsapp &&
            Array.isArray(robo.funcionarios_whatsapp)
          ) {
            // Adiciona cada funcionário ao array com a propriedade `selecionado` com base no celular
            this.pessoasReceberMensagens.push(
              ...robo.funcionarios_whatsapp.map((funcionario) => ({
                ...funcionario,
                selecionado: funcionario.celular ? true : false, // Marca se celular estiver informado
              }))
            );
          } else {
            console.warn(
              "Robô sem dados de funcionários ou dados inválidos:",
              robo
            );
          }
        });

        // Remove duplicados com base no ID do funcionário
        this.pessoasReceberMensagens = this.pessoasReceberMensagens.filter(
          (item, index, self) => index === self.findIndex((t) => t.id === item.id)
        );
      }

      // Construir a mensagem diretamente
      this.mensagemWhatzap = `
**Chamado No**
${chamado.id}
**Tipo Manutenção:**
${chamado.tipo_manutencao.tipo_manutencao}
**Chefe de Setor:**
${chamado.funcionario_abertura.nome}
**No Máquina:**
 ${chamado.maquina.id}
**Máquina:**
${chamado.maquina.descricao_maquina}
**Modelo:**
${chamado.maquina.modelo}
**Setor:**
${chamado.setor.descricao_setor}
**Prioridade:**
${chamado.prioridade.prioridade}
**Fila:**
${chamado.maquina.fila} - **Posição:** ${chamado.maquina.posicao}
**Observação:**
 ${chamado.observacao_abertura || "Sem observações"}
`.trimStart();

//alert(this.mensagemWhatzap);
          this.mensagemDialog = "Chamado aberto com sucesso. Enviando mensagem mecanico ";
          this.loadingDialog = true; // Ativa o indicador de carregamento

          try {
            //  como ele vai esperar aqui essa chamad
            await this.confirmarWhatzap();
          } catch (whatsappError) {
            console.error("Erro ao enviar WhatsApp:", whatsappError);
            toast.warning("Chamado aberto, mas houve erro ao enviar WhatsApp");
          }
        } 

        this.modalSucesso = true; // Abre o modal de sucesso
        this.loadingDialog = false; // Desativa o indicador de carregamento

      } else {
        this.loadingDialog = false; // Ativa o indicador de carregamento
        throw new Error(response?.message || "Erro ao abrir chamado.");
      }

      } catch (error) {
        this.loadingDialog = false; // Ativa o indicador de carregamento
        console.error(error);

        toast.error("Erro ao abrir chamado.");
      }
    },

  },
  mounted() {

    this.carregarMecanicos();
  },
};
</script>

<style scoped>
.v-btn {
  margin-top: 10px;
}

ul {
  list-style-type: none;
  padding: 0;
}

ul li {
  margin-bottom: 5px;
  display: flex;
  align-items: center;
}

ul li v-btn {
  margin-left: 10px;
}


.dialog-content {
  max-height: 70vh;
  /* Altura máxima en telas grandes */
  overflow-y: auto;
  overflow-x: auto;
  transition: padding-bottom 0.3s ease;
  /* Adiciona uma transição suave */
}

.buttons-container {
  padding: 16px;
  margin-top: 16px;
  background-color: white;
}

.mb-1 {
  margin-bottom: 4px;
}

.sub-setor-text span {
  font-size: 0.875rem;
  color: #666;
}

/* Estilos para o Card do Chefe */
.chefe-card {
  padding: 16px;
  background-color: #f5f5f5;
  border-radius: 8px;
}

.funcionario-card {
  padding: 16px;
  background-color: #e8f5e9;
  border-radius: 8px;
}

.chefe-foto,
.funcionario-foto {
  width: 100%;
  height: auto;
  object-fit: cover;
  border-radius: 50%;
}

.funcionario-foto {
  width: 80px;
  height: 80px;
}

.chefe-nome {
  font-size: 1.5rem;
  font-weight: bold;
}

.funcionario-nome {
  font-size: 1.2rem;
  font-weight: bold;
}

.chefe-info-col,
.funcionario-info-col {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.maquina-chip {
  margin-right: 4px;
  margin-top: 4px;
}


@media (min-width: 601px) {
  .v-dialog__content .v-card {
    max-width: 600px;
    /* Limita a largura para melhorar a visualização em telas maiores */
    margin: auto;
    /* Centraliza a caixa de diálogo */
  }

  .buttons-container {
    position: sticky;
    bottom: 0;
    z-index: 1;
  }
}

/* Ajustes para dispositivos móveis */
@media (max-width: 600px) {
  .v-dialog__content .v-card {
    width: 100vw;
    height: 100vh;
    max-width: 100vw;
    margin: 0;
    padding: 0;
  }

  @media (max-width: 600px) {
    .v-toolbar-title.text-h5 {
      font-size: 1.2rem;
    }
  }

  .buttons-container {
    position: sticky;
    bottom: 0;
    z-index: 1;
  }

  .dialog-content {
    max-height: calc(100vh - 50px);
    /* Ajusta a altura para compensar o teclado */
    padding-bottom: 0;
    /* Padding inicial para o ajuste */
  }
}



@media (min-width: 600px) {

  .chefe-foto-col,
  .funcionario-foto-col {
    max-width: 200px;
  }

  .chefe-foto {
    height: 200px;
  }

  .funcionario-foto {
    width: 60px;
    height: 60px;
  }

  .chefe-nome {
    font-size: 2rem;
  }

  .funcionario-nome {
    font-size: 1.5rem;
  }
}

.title-sheet {
  background: linear-gradient(to right, #e0e0e0, #f5f5f5);
  /* Degradê cinza */
  width: 100%;
  /* Largura total */
  padding: 8px;
  /* Espaçamento interno */
}

.title-text {
  margin: 0;
  /* Remove a margem padrão do h3 */
  text-align: center;
  /* Centraliza o texto */
  color: #424242;
  /* Cor do texto para melhor contraste */
}

.maquinas-lista-container {
  max-height: 500px;
  /* Ajuste a altura máxima conforme necessário */
  min-width: 100%;
  overflow-y: auto;
}

.maquinas-lista-container::-webkit-scrollbar {
  width: 8px;
}

.maquinas-lista-container::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 4px;
  padding: 0;
}

.maquinas-lista-container::-webkit-scrollbar-track {
  background-color: transparent;
}


.info-row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  font-weight: bold;
}

.info-item {
  flex: 1;
  margin-right: 10px;
  font-weight: bold;
}

.info-value {
  text-align: center;
  padding: 5px;
  border-bottom: 1px solid #ddd;
  font-weight: normal;
}
</style>
